import React from 'react'
import { withTranslation } from "react-i18next";
import { TbInfoTriangle } from "react-icons/tb";
import infoimg from "../../../assets/images/all/infoimg.svg";

const ZeroBalancePop = (props) => {

  return (
    <div className='information-img'>
      <h2>{props.t('information')}</h2>
      <TbInfoTriangle className="info-icon"/>
      <p>{props.t('your_balance_insufficient')}</p>
    </div>
  )
}

export default withTranslation()(ZeroBalancePop)
